import { useTranslation } from "react-i18next";
import { generatePath, useHistory } from "react-router-dom";
import routing from "routing";
import { IconButton } from "src/components/Default/LekUI/Button";
import { Tooltip } from "src/components/Default/LekUI/Tooltip";
import { useModals } from "src/components/Modals/context/ModalProvider";
import { ModalsNames } from "src/components/Modals/context/modals";
import { isFinishedExam, isMultiAnswersExam } from "src/helpers/examHelpers";
import ChartIcon from "src/images/Icons/newIcons/chart.svg";

import ExamMenuActions from "../../menuActions/ExamActions";
import ExamActions from "../Actions/ExamActions";
import ExamDetails from "../Details/ExamDetails";
import DefaultScoreView from "./DefaultScoreView";

export const ExamStatisticsIconButton = ({ exam }) => {
	const { t } = useTranslation();
	const { openModal } = useModals();
	const isDisabled =
		isMultiAnswersExam(exam.type) && !isFinishedExam(exam.status);

	const tooltip = isDisabled
		? t("modals.statistics.tooltips.blocked")
		: t("modals.statistics.tooltips.stats");

	return (
		<Tooltip title={tooltip}>
			<IconButton
				disabled={isDisabled}
				className="menu-icon-button menu-icon-button--icon-blue"
				onClick={() => {
					openModal(ModalsNames.ExamStatisticsModal, {
						examId: exam.id,
					});
				}}
			>
				<ChartIcon className="icon-small" />
			</IconButton>
		</Tooltip>
	);
};

export default function ExamView({ row, className, hideButton = false }) {
	const history = useHistory();

	const onPrimary = () => {
		if (row.status === "active") {
			return history.push(generatePath(routing.paths.exam, { id: row.id }));
		}

		return history.push(
			generatePath(routing.paths.exam, { id: row.id, questionId: 1 }),
		);
	};

	return (
		<DefaultScoreView
			className={className}
			data-exam-id={row.id}
			Details={<ExamDetails row={row} className="mr-12" />}
			Actions={
				!hideButton && (
					<ExamActions
						row={row}
						onPrimary={onPrimary}
						menuActions={<ExamMenuActions row={row} />}
						renderStats={<ExamStatisticsIconButton exam={row} />}
					/>
				)
			}
		/>
	);
}
